module.exports = __webpack_public_path__ + "img/online_bg_2023_01_19.521e9c9e.png";